/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description messagedView constants
 */

// listables action
export const BEGIN_FETCHING_LISTABLES = '@@nzr/messagedView/BEGIN_FETCHING_LISTABLES'
export const RECEIVE_LISTABLES = '@@nzr/messagedView/RECEIVE_LISTABLES'
export const DONE_FETCHING_LISTABLES = '@@nzr/messagedView/DONE_FETCHING_LISTABLES'

// view action
export const HIDE = '@@nzr/messagedView/HIDE'
export const SHOW = '@@nzr/messagedView/SHOW'

// misc
export const RESET = '@@nzr/messagedView/RESET'
